import { render, staticRenderFns } from "./dealerhospitalmaintenanceindicators.vue?vue&type=template&id=27124a39&scoped=true&"
import script from "./dealerhospitalmaintenanceindicators.vue?vue&type=script&lang=js&"
export * from "./dealerhospitalmaintenanceindicators.vue?vue&type=script&lang=js&"
import style0 from "./dealerhospitalmaintenanceindicators.vue?vue&type=style&index=0&id=27124a39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27124a39",
  null
  
)

export default component.exports